var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 28C55.5 43.1878 43.1878 55.5 28 55.5C12.8122 55.5 0.5 43.1878 0.5 28C0.5 12.8122 12.8122 0.5 28 0.5C43.1878 0.5 55.5 12.8122 55.5 28Z",
    stroke: "black",
    strokeOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9978 10.1819V23.352L39.4473 28.3261L27.9978 10.1819Z",
    fill: "black",
    fillOpacity: 0.602
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9969 10.1819L16.5459 28.3261L27.9969 23.352V10.1819Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9978 36.861V45.8099L39.455 30.3992L27.9978 36.861Z",
    fill: "black",
    fillOpacity: 0.602
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9969 45.8099V36.8595L16.5459 30.3992L27.9969 45.8099Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9978 34.7899L39.4473 28.3266L27.9978 23.3555V34.7899Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5459 28.3266L27.9969 34.7899V23.3555L16.5459 28.3266Z",
    fill: "black",
    fillOpacity: 0.602
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.a9d69dd5.svg";
export { ForwardRef as ReactComponent };